/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import _ from 'lodash';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

interface ISelectOption {
    title: string;
    value: any;
    disabled: boolean;
}

const FormikSelect = ({ field: { ...fields }, ...props }): React.ReactNode => {
    const { defaultOption, sx, fullWidth = true, hasObject = false, className, MenuProps, ...rest } = props;

    return (
        <FormControl fullWidth={fullWidth} className={`${className}`}>
            <InputLabel title={props.label}>{props.label}</InputLabel>
            <Select
                {...fields}
                {...rest}
                MenuProps={{
                    ...MenuProps,
                    PaperProps: {
                        className: 'select-wrapper',
                    },
                }}
                sx={sx}
            >
                {defaultOption && <MenuItem value={typeof fields.value === 'string' ? '' : 0}> -- Select -- </MenuItem>}
                {props.options &&
                    props.options.map((option: ISelectOption) => (
                        <MenuItem
                            key={option.value}
                            value={option.value}
                            disabled={option?.disabled ? option?.disabled : false}
                        >
                            {option.title}
                        </MenuItem>
                    ))}
            </Select>
        </FormControl>
    );
};

export default FormikSelect;
